module.exports = __webpack_public_path__ + "img/x-pay-logo.b5c95c13.svg";